module.exports = (configProvider, merchantId, env, authMode, authUrl) => {
  configProvider.set({
    merchantId: merchantId,
    env: env,
    auth: {
      type: authMode,
      authUrl: authUrl
    }
  });
};

module.exports.$inject = ['ogsdk.configProvider', 'merchantId', 'env', 'authMode', 'authUrl'];
